import React, { useState } from 'react';

function VideoCard({ video, onSetFeatured, onUpdateTitle, onDelete, onCardClick, isAdmin }) {
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState('');

  return (
    <div className="card" onClick={() => onCardClick && onCardClick(video)}>
      {video.thumbnail && <img src={video.thumbnail} alt={video.title || 'Video'} />}
      <div className="card-body">
        {editingId === video.id ? (
          <div className="title-edit">
            <input
              type="text"
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              placeholder="Enter title"
              autoFocus
            />
            <button onClick={() => { onUpdateTitle(video.id, editTitle); setEditingId(null); }}>Save</button>
            <button onClick={() => setEditingId(null)}>Cancel</button>
          </div>
        ) : (
          <p
            className="card-title"
            onClick={(e) => { if (isAdmin) { e.stopPropagation(); setEditingId(video.id); setEditTitle(video.title); } }}
            style={{ cursor: isAdmin ? 'pointer' : 'default' }}
          >
            {video.title || 'Untitled'}
          </p>
        )}
        {isAdmin && editingId !== video.id && (
          <div className="card-actions">
            <button className="btn-feature" onClick={(e) => { e.stopPropagation(); onSetFeatured(video); }}>Feature</button>
            <button className="btn-delete" onClick={(e) => { e.stopPropagation(); onDelete(video.id); }}>Delete</button>
          </div>
        )}
      </div>
    </div>
  );
}

function VideoGrid({ videos, onSetFeatured, onUpdateTitle, onDelete, onCardClick, isAdmin }) {
  return (
    <div>
      <p className="section-heading">All Performances</p>
      <div className="card-grid">
        {videos.map(video => (
          <VideoCard
            key={video.id}
            video={video}
            onSetFeatured={onSetFeatured}
            onUpdateTitle={onUpdateTitle}
            onDelete={onDelete}
            onCardClick={onCardClick}
            isAdmin={isAdmin}
          />
        ))}
      </div>
    </div>
  );
}

export default VideoGrid;
